import type { NavbarSerializableNode } from './Serializer.types';

export function filterRows(node: NavbarSerializableNode) {
  if (node.type !== 'navbar_menu') return node;
  let { content, ...rest } = node;
  if (node.attrs?.rows === 1) {
    const firstList = content?.[0];
    if (!firstList) return node;
    content = [firstList];
  }
  return {
    ...rest,
    content,
  };
}
